import { Helmet } from "react-helmet-async"
import ManualUploadForm from "./ManualUploadForm"
import FileUploadForm from "./FileUploadForm"

// TODO: Add form wrapper once decision has been made on which form pattern to use
// TODO: Update styling to tailwind
// TODO: Write Specs

const MassNotate = () => {
  return (
    <>
      <Helmet title="Mass Notate" />
      <h1 className="p-3 font-weight-bold">Mass Notate</h1>
      <ManualUploadForm />
      <FileUploadForm />
    </>
  )
}

export default MassNotate
